import { darken, makeStyles } from '@material-ui/core'

import { lang } from '../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 12,
    paddingBottom: 12,
    textAlign: 'center',
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.2)
        : '#f3f3f3',
    borderRadius: 12,
    cursor: 'pointer',
    border: `2px solid ${theme.palette.background.default}`,
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content'
  },
  active: {
    backgroundColor: theme.palette.background.default,
    border: `2px solid ${theme.palette.primary.main}`
  },
  activeCircle: {
    position: 'absolute',
    top: 10,
    left: 10,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  },
  skeleton: {
    width: '40%',
    marginLeft: '30%'
  },
  skeleton2: {
    width: '60%',
    marginLeft: '20%'
  },
  providerText: {
    fontWeight: lang === 'en' ? 900 : 800
  },
  roomTypeText: {
    padding: '8px 0px'
  },
  ratePlanText: {
    paddingBottom: 4
  }
}))

export default useStyles
